module.exports = __webpack_public_path__ + "img/33.4f15f87b.png";